import React from "react";

import PageRenderControls from "@agent-ui/features/page-renderer/components/PageRenderControls";
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "@replo/design-system/components/tabs/Tabs";
import { MessageSquareMore, Smartphone } from "lucide-react";

type Props = {
  pageRoute: string | null;
  isLoading: boolean;
  mode: "chat" | "preview";
  onModeChange: (mode: "chat" | "preview") => void;
};

export default function MobileChatFooter({
  pageRoute,
  isLoading,
  mode,
  onModeChange,
}: Props) {
  return (
    <div className="md:hidden w-full bg-white shadow-xs p-3 flex flex-col gap-3 border-t-0.5 border-border">
      {mode === "preview" && (
        <PageRenderControls isLoading={isLoading} pageRoute={pageRoute} />
      )}

      <Tabs
        value={mode}
        onValueChange={(v) => onModeChange(v as "chat" | "preview")}
      >
        <TabsList className="h-11">
          <TabsTrigger
            value="chat"
            startEnhancer={<MessageSquareMore className="size-4" />}
          >
            Chat
          </TabsTrigger>
          <TabsTrigger
            value="preview"
            disabled={!pageRoute}
            startEnhancer={<Smartphone className="size-4" />}
          >
            Preview
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
